import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { StepWithAlerts } from '../components/StepWithAlerts/StepWithAlerts.js';
import { PrescriptionForm } from './components/PrescriptionForm/PrescriptionForm.js';
import { PrescriptionFormLabelDetails } from './components/PrescriptionFormLabelDetails/PrescriptionFormLabelDetails.js';

const PrescriptionFormStep = (stepWithAlertsProps)=>{
    return /*#__PURE__*/ React.createElement(StepWithAlerts, swcHelpers.extends({}, stepWithAlertsProps, {
        descriptionSuffix: /*#__PURE__*/ React.createElement(PrescriptionFormLabelDetails, null)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "rx-form-step"
    }, /*#__PURE__*/ React.createElement(PrescriptionForm, {
        className: "rx-form-step__form"
    })));
};

export { PrescriptionFormStep };
//# sourceMappingURL=PrescriptionFormStep.js.map
